import MultipleRealms from "screens/public/multiple-realms";
export default MultipleRealms;
